import styled from 'styled-components';


const Wrapper = styled.div`
  position: relative;
  z-index: 10;
  pointer-events: none;
`

const StyledDiv = styled.div`
  width: 45%;
  display: flex;
  justify-content: center;

  &.logo{ padding-top: 10px; }

  &.menu-actions{
    @media (max-width:767px) {
      width: 60px !important;
      
    }

    @media (min-width:768px) {
      justify-content: flex-end;
      padding-right: 76px;
    }
  }

  @media (min-width:768px) {
    align-items: flex-start;
    width: 20%;
    padding-top: 46px;

    &.logo{ padding-top: 44px; }
  }
`;
  
const StyledHeader = styled.header`
  width: 100%;
  display: flex;
  justify-content: space-between;
  height: 10em;

  @media (max-width: 600px) {
    height: 5em;
  }
`;

export const HamburguerWrapper = styled.div`
  pointer-events: all;
`

const SvgDiv = styled.div`
  margin-top: 25px;
  margin-left: 8px;
  height: 35px;

  svg {
    width: 40px;
    height: auto;
  }

  @media (min-width: 768px) {
    padding-left: 60px;
    margin-top: 55px;
    height: 50px;
    width: 20%;
  }
`;

export { SvgDiv, StyledDiv, StyledHeader, Wrapper }
